module.exports = __webpack_public_path__ + "img/orange-lily.61cc23f7.jpg";